
<template>
  <div id="HOLIC">
    <div class="event_wrap type2 type_05">
      <div class="event_view">
        <div>
          <span>
            <img
              alt="취향저격 Holic 요금제 출시"
              src="/content/images/partnership/220613_holic_img01.png"
            ><img
              alt="Holic 요금제 안내"
              src="/content/images/partnership/220613_holic_img02.png"
            ><img
              alt="취향 대로 선택하신 후 한번 가입하면 매달 알아서 챙겨드려요!!"
              src="/content/images/partnership/220613_holic_img03.png"
            >
          </span>
          <div class="event_view_field">
            <div class="insWrap">
              <div class="check_box chkAll">
                <input
                  id="yesAll"
                  v-model="agreePrivacy"
                  name="yesno"
                  type="checkbox"
                  value="yesAll"
                  @click="checkAll"
                >
                <label for="yesAll"> <span>SK국제전화 요금제 이용 동의 및 개인정보 수집에 모두 동의합니다.</span></label>
              </div>

              <div class="check_box">
                <input
                  id="yes1"
                  v-model="agreePrivacy1"
                  name="yesno1"
                  type="checkbox"
                  value="yes01"
                  @click="checkRequired"
                >
                <label for="yes1"> <span>(필수) SK국제전화 요금제 이용 동의</span></label>
                <a
                  v-if="!isVisiblePrivacy1"
                  class="btn_view"
                  @click="isVisiblePrivacy1 = true"
                >자세히 보기</a>
                <a
                  v-if="isVisiblePrivacy1"
                  class="btn_view close"
                  @click="isVisiblePrivacy1 = false"
                >자세히 보기</a>
              </div>
              <div
                v-if="isVisiblePrivacy1"
                class="privacyCnt"
              >
                <p>
                  가입하시고자 하는 본 상품은 00700 가입형 요금제로 매월 기본료 11,000원(VAT포함)이 매월 청구됩니다.<br>
                  본인은 매월 기본료 정기 청구를 진행하는 것에 동의합니다. 고객님은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다.<br>
                  단, 본 동의는 서비스의 본질적 기능 제공을 위해 동의로서, 동의를 하는 경우에만 서비스 이용이 가능합니다.
                </p>
              </div>

              <div class="check_box">
                <input
                  id="yes2"
                  v-model="agreePrivacy2"
                  name="yesno2"
                  type="checkbox"
                  value="yes02"
                  @click="checkRequired"
                >
                <label for="yes2"> <span>(필수) 개인정보 수집 동의</span></label>
                <a
                  v-if="!isVisiblePrivacy2"
                  class="btn_view"
                  @click="isVisiblePrivacy2 = true"
                >자세히 보기</a>
                <a
                  v-if="isVisiblePrivacy2"
                  class="btn_view close"
                  @click="isVisiblePrivacy2 = false"
                >자세히 보기</a>
              </div>
              <div
                v-if="isVisiblePrivacy2"
                class="privacyCnt"
              >
                <p>
                  SK텔링크 주식회사는 국제전화 이용에 대한 혜택제공을 위해 아래와 같이 고객정보를 수집하며,<br>고객정보 취급에 관한 상세한 사항은 <a
                    class="txt_point01"
                    href="www.sktelink.com/privacy/intro"
                  >www.sktelink.com/privacy/intro</a>에 게시된 개인정보처리방침을 참조하시기 바랍니다.
                </p>
                <ul>
                  <li>수집하는 개인정보의 항목 : 휴대폰번호(연락처)</li>
                  <li>개인정보의 수집 및 이용목적 : SK국제전화 요금제에 대한 고객상담 진행</li>
                  <li>개인정보의 보유 및 이용기간 : <strong>SK국제전화 요금제 가입 시점부터 해지일자까지</strong></li>
                </ul>
                <p>개인정보 수집에 대한 동의/거부할 권리가 있으나, 거부 시 요금제 혜택 제공에 제한이 될 수 있습니다.</p>
                <p>SK국제전화 요금제 혜택을 받기 위해 위와 같이 본인의 개인정보 수집하는 것에 동의합니다.</p>
              </div>

              <div class="table_type01">
                <dl>
                  <dt>요금제</dt>
                  <dd>
                    <div class="select_box">
                      <select
                        id="i_sUserNm"
                        ref="select1"
                        v-model="selectRatePlan"
                        name="i_sUserNm"
                        title="요금제 선택하기"
                      >
                        <option value="요금제 선택">
                          요금제 선택
                        </option>
                        <option value="COZHA">
                          커피홀릭(스타벅스)요금제
                        </option>
                        <option value="COZHC">
                          커피홀릭(투썸플레이스)요금제
                        </option>
                        <option value="COZHE">
                          커피홀릭(할리스)요금제
                        </option>
                        <option value="COZHB">
                          편의점홀릭(CU)요금제
                        </option>
                        <option value="COZHD">
                          편의점홀릭(GS)요금제
                        </option>
                        <option value="COZHF">
                          편의점홀릭(세븐일레븐)요금제
                        </option>
                      </select>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>본인인증</dt>
                  <dd>
                    <div class="phone-box_wrap">
                      <div class="phone-box">
                        <div class="select_box">
                          <select
                            id="call_select01"
                            ref="telNumberFirst"
                            v-model="telNumber.first"
                            name="i_sHpNo1"
                            title="무선전화 앞자리 선택"
                          >
                            <option value="010">
                              010
                            </option>
                            <option value="011">
                              011
                            </option>
                            <option value="016">
                              016
                            </option>
                            <option value="017">
                              017
                            </option>
                            <option value="018">
                              018
                            </option>
                            <option value="019">
                              019
                            </option>
                          </select>
                        </div>
                        <span class="txt_hyphen">-</span>
                        <input
                          ref="telNumberMiddle"
                          v-model="telNumber.middle"
                          name="i_sHpNo2"
                          title="전화번호"
                          type="text"
                          maxlength="4"
                          pattern="[0-9]*"
                          class="numbersOnly"
                          inputmode="numeric"
                          oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                        >
                        <span class="txt_hyphen">-</span>
                        <input
                          ref="telNumberLast"
                          v-model="telNumber.last"
                          name="i_sHpNo3"
                          title="전화번호"
                          type="text"
                          maxlength="4"
                          pattern="[0-9]*"
                          class="numbersOnly"
                          inputmode="numeric"
                          oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                        >
                      </div>
                      <a
                        class="btn"
                        @click="requestSMSCert"
                      >본인 인증하기</a>
                    </div>
                  </dd>
                </dl>
                <dl
                  v-if="authNumberInputVisible"
                  id="numberCheck"
                  class="cert"
                >
                  <dt>인증번호 입력</dt>
                  <dd>
                    <input
                      ref="certNumber"
                      v-model="auth_no"
                      name="i_sCertificationNo"
                      title="인증번호"
                      type="text"
                      maxlength="6"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    ><a
                      class="btn"
                      @click="requestCert"
                    >인증번호확인</a>
                  </dd>
                </dl>
              </div>

              <div class="table_msg">
                ※ 요금제에 가입하시려는 핸드폰번호의 본인 명의 인증수단으로 본인인증을 진행해주세요.
              </div>

              <div class="btnWrap">
                <a
                  id="btnApply"
                  class="btn_type01"
                  @click="registrationFinal"
                >요금제 가입하기</a>
              </div>
            </div>
          </div>
          <div class="event_view_field">
            <div class="event_caution">
              <h1>유의사항</h1>
              <ul>
                <li>본 요금제는 2022년에 한하여 가입이 가능한 가입형 요금제입니다.</li>
                <li>본 요금제 가입을 위해선 개인정보 수집 및 활용, 취급위탁에 대한 동의가 필요합니다.</li>
                <li>본 요금제에 대한 가입 혜택은 국제전화 00700 에 대해서만 적용됩니다.</li>
                <li>SK국제전화에서 판매 중인 타 국제전화요금제와 중복가입이 불가합니다.</li>
                <li>불법스팸, 상업적 용도 등 불법적인 국제전화 이용 시 즉시 서비스 제공이 중단됩니다.</li>
                <li>월 제공분수 초과 이용시, 초과분에 대해서는 00700 표준요금이 적용됩니다.</li>
                <li>요금월(무선주기 : 전월21일~당월20일) 중도에 해당 요금제를 가입 또는 해지하는 경우 기본료는 월할 계산으로 적용됩니다.</li>
                <li>화상/위성전화 등 특수대역대 이용시 무료통화는 적용되지 않으며, 선불폰 이용은 불가합니다.</li>
                <li>가입하신 핸드폰번호 변경 시 모바일 상품권 수신이 이루어지지 않을 수 있사오니 당사 고객센터로 연락하셔서 번호 변경을 해주셔야 합니다.</li>
                <li>핸드폰번호 변경으로 인하여 모바일 상품권이 수신이 이루어지지 않을 경우 당사는 책임지지 않습니다.</li>
                <li>모바일 상품권 브랜드는 중복 선택이 불가합니다.</li>
                <li>모바일 상품권은 청구 익월 1주차, 2주차, 3주차 월요일에 1매씩 발송되며 3매 일괄 발송은 불가합니다.</li>
                <li>회사 제반 사정(모바일 상품권 제공사업자와의 계약종료, 원가 상승 등)으로 상품 및 서비스를 더 이상 유지할 수 없는 상품을 종료 할 수 있습니다.</li>
              </ul>
              <dl>
                <dt>* 요금제 관련 자세한 문의는 SK국제전화 고객센터로 연락 부탁 드립니다.</dt>
                <dd>고객센터 전화번호 : 1599-0070</dd>
                <dd>운영시간 : 월~금(오전9시~오후6시)</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 팝업 -->
    <Popup
      :is-visible.sync="alertPopup.visible"
      :pop-title="'확인'"
      :c-type="'btn_type02'"
      @click="alertPopupHandler"
    >
      <p v-html="alertPopup.message" />
    </Popup>
    <!-- //팝업 -->
  </div>
</template>

<script>
import api from '@/api'
import Popup from '@/components/popup/Popup'
export default {
  name: 'AllPass',
  components: {
    Popup
  },
 props: {
 },
 emits: [
 ],
 data () {
  return {
    isVisiblePrivacy1: false,
    isVisiblePrivacy2: false,
    agreePrivacy:false,
    agreePrivacy1:false,
    agreePrivacy2:false,
    alertPopup: {
      visible: false,
      message: '',
      target: ''
    },
    telNumber:{
      first:'010',
      middle: '',
      last:''
    },
    authNumberInputVisible: false,
    ticket: '',
    event_no:'EV000000000000000009',
    auth_no: '',
    selectRatePlan:'요금제 선택',
    add_info: ''
  }
 },
 computed: {
  svc_tel_no() {
    return `${this.telNumber.first}${this.telNumber.middle}${this.telNumber.last}`
  },
  callbackAlert(){
    return this.$store.getters.CALLBACK_ALERT
  }
 },
 watch: {
  callbackAlert: {
    deep: true,
    handler() {
      if (this.callbackAlert.code === '0002' || this.callbackAlert.code === 'E011' || this.callbackAlert.code === 'E018' || this.callbackAlert.code === 'E0027' || this.callbackAlert.code === 'E028' || this.callbackAlert.code === 'E029' || this.callbackAlert.code === 'E016' || this.callbackAlert.code === 'E017' || this.callbackAlert.code === 'E021' || this.callbackAlert.code === 'E022' || this.callbackAlert.code === 'E045') {
        this.resetPage()
        window.scrollTo(0, 0)
        document.getElementById('wrap').scrollTop = 0
      }
      if (this.callbackAlert.code === 'E002') {  // 인증5회 오류
        this.authNumberInputVisible = false,
        this.telNumber = {
          first:'010',
          middle: '',
          last:''
        },
        this.auth_no = ''
        this.ticket = ''
      }
      if (this.callbackAlert.code === 'E001') { // 인증시간 초과
        this.auth_no = ''
        this.ticket = ''
      }
    }
  }
},
 created () {},
 mounted () {
 },
 methods: {
  alertPopupHandler() {
    this.alertPopup.visible = false
    this.alertPopup.message = ''
    if (this.alertPopup.target) {
      this.$refs[this.alertPopup.target].focus()
    }
    this.alertPopup.target = ''
  },
  showAlertPopup(message) {
    this.alertPopup.message = message
    this.alertPopup.visible = true
  },
  checkPhoneNumber() {
    if (!this.telNumber.first) {
      this.alertPopup.target = 'telNumberFirst'
      this.showAlertPopup('휴대폰 번호를 입력해 주세요.')
      return false
    } else if (!this.telNumber.middle) {
      this.alertPopup.target = 'telNumberMiddle'
      this.showAlertPopup('휴대폰 번호를 입력해 주세요.')
      return false
    } else if (!this.telNumber.last) {
      this.alertPopup.target = 'telNumberLast'
      this.showAlertPopup('휴대폰 번호를 입력해 주세요.')
      return false
    } else if(this.telNumber.middle.length < 3 || this.telNumber.last.length < 4) {
      this.showAlertPopup('휴대폰 번호가 유효하지 않습니다.')
      return false
    } else {
      return true
    }
  },
  checkAuthNumber() {
    if (!this.auth_no) {
      this.alertPopup.target = 'certNumber'
      this.showAlertPopup('인증번호를 입력해 주세요.')
      return false
    } else {
      return true
    }
  },
  checkSMSCert() {
    if(!this.isSmsCert) {
      this.showAlertPopup('SMS인증을 완료해 주세요.')
      return false
    } else {
      return true
    }
  },
  checkselect(){
    if(!this.agreePrivacy){
      this.showAlertPopup('개인정보 수집에 동의하셔야 신청이 가능합니다.')
      return false
    }else if(this.selectRatePlan ==='요금제 선택'){
      this.showAlertPopup('요금제를 선택해주세요.')
      return false
    }else {
      return true
    }
  },
  // SMS 인증 요청
  requestSMSCert() {
    if (this.checkPhoneNumber()) {
      api.CommonPostReqSmsAuth({ svc_tel_no: this.svc_tel_no })
      .then(response => {
        if (response.data.sms_ticket) {
          this.showAlertPopup('인증번호가 정상적으로 발송되었습니다.')
          this.ticket = response.data.sms_ticket
          this.authNumberInputVisible = true
        }
      })
    }
  },
  // 인증 번호로 SMS 인증 확인
  requestCert() {
    if (this.checkAuthNumber()) {
      api.CommonGetCheckSmsAuth({ auth_no: this.auth_no, sms_ticket: this.ticket })
      .then(response => {
        if (response.data.result_cd === '0001') {
          this.isSmsCert = true
          this.showAlertPopup('인증번호가 확인되었습니다.<br>감사합니다.')
        }
      })
    }
  },
  //신청완료
  registrationFinal() {
    if (this.checkselect() && this.checkPhoneNumber() && this.checkSMSCert()) {
      api.EventPostReqEvent({
        sms_ticket: this.ticket,
        event_no: this.event_no,
        add_info: this.selectRatePlan
      })
    }
  },
  resetPage(){
    this.agreePrivacy = false,
    this.agreePrivacy1 = false,
    this.agreePrivacy2 = false,
    this.telNumber= {
      first:'010',
      middle: '',
      last:''
    },
    // this.selectBenefit = '혜택을 선택해주세요',
    this.authNumberInputVisible = false,
    this.selectRatePlan = '요금제 선택',
    this.auth_no = ''
    this.ticket = ''
    this.isSmsCert = false
  },
  checkAll() {
    if(!this.agreePrivacy){
      this.agreePrivacy1 = true
      this.agreePrivacy2 = true
    } else {
      this.agreePrivacy1 = false
      this.agreePrivacy2 = false
    }
  },
  checkRequired() {
    const ck1 = document.getElementById('yes1').checked
    const ck2 = document.getElementById('yes2').checked
    if(ck1 && ck2){
      this.agreePrivacy = true
    } else {
      this.agreePrivacy = false
    }
  }
 }
}
</script>

<style lang="scss" scoped>

.check_box {
  display: block;
  position: relative;
  margin-top: 14px;
  padding-left: 17px;
  line-height: normal;
  & > input:checked {
    & + label {
      background-image: url('/content/images/partnership/220613_holic_checkbox_on.png');
      background-size: 26px;
    }
  }
  &.chkAll {
    margin-bottom: 20px;
    label {
      span {
        color: #333;
        font-size: 27px;
        font-weight: 700;
      }
    }
  }
  label {
    & > * {
      font-family: 'GmarketSans';
    }
    padding-left: 43px;
    line-height: normal;
    background-image: url('/content/images/partnership/220613_holic_checkbox.png');
    background-position: 0 0;
    background-size: 26px;
    span {
      color: #303c43;
      font-size: 24px;
      font-family: 'GmarketSans';
      font-weight: 500;
      line-height: normal;
    }
  }
  .btn_view {
    position: absolute;
    top: 4px;
    right: 25px;
    padding: 0 0 0 40px;
    color: #5e5e5e;
    font-size: 20px;
    font-family: 'GmarketSans';
    font-weight: 500;
    background: none;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 6px;
      width: 16px; height: 9px;
      background: url('/content/images/partnership/220613_holic_arrow.png') no-repeat;
    }
    &.close {
      &:before {
        transform: rotate(180deg);
      }
    }
  }
}

.insWrap {
  padding: 100px 120px 80px;
  background-color: #f6f4ff;

  .table_type01 {
    width: 100%;
    margin-top: 50px;
    border-color: #222;
    dl {
      &:first-child {
        border-top-width: 0;
      }
      border-top-color: #e2e2e2;
      border-top-style: solid;
      dt {
        min-width: 180px;
        color: #303c43;
        font-size: 22px;
        font-family: 'GmarketSans';
        font-weight: 500;
        background-color: #eaeaea;
      }
      dd {
        padding: 10px 25px 10px;
        background-color: #fff;
        .phone-box {
          display: inline-block;
        }
        a {
          height: 53px;
          color: #fff;
          font-size: 18px;
          font-family: 'GmarketSans';
          font-weight: 500;
          line-height: 53px;
          background-color: #222;
          border: 1px solid #a7a7a7;
        }
        .select_box {
          height: auto;
          select {
            position: static;
            min-width: 150px;
            height: 53px;
            padding-left: 15px;
            color: #505050;
            font-size: 18px;
            font-family: 'GmarketSans';
            font-weight: 500;
            line-height: 53px;
            background: #fff url('/content/images/partnership/220613_holic_arrow.png') no-repeat right 15px center;
            border: 1px solid #eee;
          }
        }
        input {
          width: 150px;
          height: 53px;
          color: #505050;
          font-size: 18px;
          font-family: 'GmarketSans';
          font-weight: 500;
          line-height: 53px;
          background-color: #fff;
          border: 1px solid #eee;
        }
        .txt_hyphen {
          padding: 0 5px;
          color: #505050;
          font-weight: bold;
        }
      }
    }
  }
  .table_msg {
    margin-top: 18px;
    color: #303c43;
    font-size: 19px;
    font-family: 'GmarketSans';
    font-weight: 500;
    text-align: center;
  }
}
.privacyCnt {
  margin: 17px 0 30px 17px;
  padding: 30px 33px 26px;
  background-color: #fff;
  border-radius: 5px;
  p {
    color: #303c43;
    font-size: 14px;
    font-family: 'GmarketSans';
    font-weight: 500;
    text-align: left;
  }
  ul {
    margin: 10px 0;
    li {
      color: #ff603a;
      font-size: 14px;
      font-family: 'GmarketSans';
      font-weight: 500;
    }
  }
}
.btnWrap {
  margin-top: 50px;
  text-align: center;
  .btn_type01 {
    height: auto;
    font-size: 30px;
    font-family: 'GmarketSans';
    font-weight: 500;
    line-height: normal;
    background-color: #ff603a;
    padding: 18px 40px 12px;
    border-radius: 35px;
  }
}
.event_caution {
  padding: 80px 60px 90px;
  color: #fff;
  background: #281a42;
  h1 {
    margin-bottom: 20px;
    color: #fea5ea;
    font-size: 38px;
    font-family: 'GmarketSans';
    font-weight:500
  }
  li, dd {
    position: relative;
    color: #fff;
    font-size: 24px;
    font-weight: 300;
    padding: 10px 0 10px 17px;
    margin-bottom: -7px;
    letter-spacing: -2px;
    line-height: 1.5;
    &:before {
      position: absolute;
      content: "-";
      top: 7px;
      left: 0;
    }
  }
  dl {
    margin-top: 40px;
    dt {
      margin-bottom: 10px;
      color: #fea5ea;
      font-size: 24px;
      font-weight: 300;
      line-height: 1.5;
    }
  }
}
@media (max-width: 1023px) {  
.check_box {
  margin-top: 7px;
  padding-left: 0;
  & > input:checked {
    & + label {
      min-height: auto;
      background-repeat: no-repeat;
      background-position: 0 3px;
      background-size: 20px;
      border: none;
    }
  }
  &.chkAll {
    margin-bottom: 10px;
    label {
      background-position: 0 0 !important;
      span {
        font-size: 18px;
      }
    }
  }
  label {
    display: block;
    min-height: auto;
    background-repeat: no-repeat;
    background-position: 0 3px;
    background-size: 20px;
    border: none;
    span {
      font-size: 16px;
      vertical-align: middle !important;
      background: none !important;
    }
  }
  .btn_view {
    position: relative;
    top: auto; right: auto; left: 27px;
    padding-left: 20px;
    font-size: 14px;
    &:before {
      background-size: 10px auto;
    }
  }
}
.insWrap {
  padding: 30px 20px 30px;
  .table_type01 {
    margin-top: 25px;
    dl {
      dt {
        min-width: auto;
        padding-top: 13px !important;
        font-size: 16px;
      }
      dd {
        padding: 5px 15px 10px !important;
        a {
          height: 44px;
          font-size: 16px;
          line-height: 44px;
        }
        .select_box {
          width: 100%;
          min-width: auto;
          background: none;
          select {
            width: 100%;
            min-width: auto;
            height: 44px;
            font-size: 16px;
            line-height: 44px;
            background-color: #fff;
            opacity: 1;
          }
        }
        input {
          width: 30%;
          height: 44px;
          font-size: 16px;
          line-height: 44px;
        }
        .phone-box {
          .select_box {
            width: 30%;
          }
        }
        .txt_hyphen {
          display: inline-block;
          width: 5%; padding: 0; text-align: center;
        }
      }
      &.cert {
        dd {
          a { width: auto; margin-top: 0; margin-left: 10px }
        }
      }
    }
  }
  .table_msg {
    margin-top: 18px;
    font-size: 15px;
  }
}
.privacyCnt {
  margin: 10px 0 15px;
  padding: 15px 15px 13px;
  p {
    font-size: 13px;
    line-height: 1.4;
  }
  ul {
    margin: 10px 0;
    li {
      font-size: 13px;
      line-height: 1.4;
    }
  }
}
.btnWrap {
  margin-top: 25px;
  .btn_type01 {
    height: auto;
    font-size: 18px;
    padding: 18px 40px 12px;
  }
}
.event_caution {
  padding: 30px 25px;
  h1 {
      margin-bottom: 10px;
      font-size: 19px;
  }
  li, dd {
    font-size: 15px;
    padding: 7px 0 7px 10px;
    letter-spacing: -1px;
    &:before {
      top: 5px;
    }
  }
  dl {
    margin-top: 20px;
    dt {
      margin-bottom: 5px;
      font-size: 15px;
    }
  }
}
}
</style>